// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__ue-8s","image":"recipe_image__7bRnZ","try":"recipe_try__10Gc7"};